import { render, staticRenderFns } from "./DepositCommunication.vue?vue&type=template&id=084b933e&lang=pug&"
import script from "./DepositCommunication.vue?vue&type=script&lang=js&"
export * from "./DepositCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports